import workspaceQuery from '../../queries/supplier/SupplierPriceMatrixWorkspaceQuery.graphql';
import instanceQuery from '../../queries/supplier/SupplierPriceMatrixQuery.graphql';
import temporaryInstanceQuery from '../../queries/supplier/SupplierPriceMatrixTemporaryQuery.graphql';
import defaultQuery from '../../queries/supplier/SupplierPriceMatrixDefault.graphql';
import mutationQuery from '../../mutations/supplier/SupplierPriceMatrixMutation.graphql';
import temporaryMutationQuery from '../../mutations/supplier/SupplierPriceMatrixTemporaryMutation.graphql';
import fragment from '../../fragments/supplier/SupplierPriceMatrixFragment.graphql';

import { formActions, workspaceActionsForPermissions } from '../../../actions/supplier/SupplierPriceMatrixAction';
import { EntityType } from '../../../@types/entityTypes';

const SupplierPriceMatrix: EntityType = {
  type: 'SupplierPriceMatrix',
  title: 'Supplier Price Matrices',
  formUrl: '/Purchasing/SupplierPricing/SupplierPriceMatrix/Details/',
  formTitle: 'Supplier Price Matrices',
  workspaceUrl: '/Purchasing/SupplierPricing/SupplierPriceMatrix/Workspace/',
  instance: instanceQuery,
  temporaryInstance: temporaryInstanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporaryUpdate: temporaryMutationQuery,
  fragment,
  screenReference: 'SUPPLIER_PRICE_MATRICES',
  actions: [...workspaceActionsForPermissions, ...formActions],
};

export default SupplierPriceMatrix;
